import api from "./config";
import { API_ENDPOINTS } from "../../utils/constants";
const notificationAPI = {
    GetNotification: async () => {
        var response = await api.get(API_ENDPOINTS.GET_NOTIFICATION_BY_ID);
        return response.data;
    },
    UpdateNotification: async (id) => {
        var response = await api.put(API_ENDPOINTS.UPDATE_NOTIFICATION + id);
        return response.data;
    },
};

export default notificationAPI;
